<template>
  <div :id="'cem-card-item-inner-' + props.item.id" style="width: 100%">
    <div
      v-if="dataTextCard && dataTextCard.length > 0"
      class="text-card"
      :class="{ clickable: hasTextCardComponentAction }"
      @click.stop="handleClickTextCardComponent"
    >
      <TextCardItem
        v-for="(item, index) in dataTextCard"
        :key="index"
        :textCardItemData="item"
        :textCardItemSetup="optionTextCard"
        :onTextCardClick="handleClickTextCardComponent"
        @showDialogDashboardPopupFromTextCardItem="
          showDialogDashboardPopupFromTextCardItem
        "
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";
import { Card_item } from "cem-probe-api";
import TextCardItem from "../TextCardItem.vue";
import MethodService from "../../service/MethodService";
import { useUrlPopupStore } from "@/stores/urlPopupStore";
const storeUrlPopup = useUrlPopupStore();
const props = defineProps({
  item: Card_item,
  itemData: null,
});
const emit = defineEmits(["showDialogDashboardPopup"]);
const dataTextCard = computed(() => props.itemData?.data);
const optionTextCard = computed(() => props.item?.text_card);
const hasTextCardComponentAction = computed(() => {
  return !!(
    optionTextCard.value?.action?.link || optionTextCard.value?.action?.popup_id
  );
});
const handleClickTextCardComponent = () => {
  const action = props.item?.text_card?.action;
  if (!action || Object.keys(action).length === 0) return;
  const hasLink = !!action.link;
  const hasPopup = !!action.popup_id;
  if (!hasLink && !hasPopup) return;
  if (hasLink) {
    const finalLink = MethodService.renderLinkChart(null, action.link);
    window.open(finalLink);
  } else if (hasPopup) {
    const chartUrl = MethodService.renderLinkChart(null, null);
    storeUrlPopup.initUrlPopup();
    storeUrlPopup.pushUrlPopup(chartUrl);
    emit("showDialogDashboardPopup", action.popup_id, chartUrl);
  }
};
const showDialogDashboardPopupFromTextCardItem = (idPopup, url) => {
  if (!idPopup || !url) return;
  storeUrlPopup.initUrlPopup();
  storeUrlPopup.pushUrlPopup(url);
  emit("showDialogDashboardPopup", idPopup, url);
};
</script>

<style lang="scss">
.text-card {
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scrollbar-gutter: stable;
  li {
    padding-bottom: 10px;
  }
  &:hover {
    overflow-y: auto;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #f0f0f0;
    border-radius: 4px;
  }

  scrollbar-width: thin;
  scrollbar-color: #f0f0f0 transparent;
  .text-card-item:last-child {
    margin-bottom: 0;
  }
}
</style>
